module.exports = __webpack_public_path__ + "static/redbooth-afb0941e691c3fd0de6c2e9dc2059cc4.svg";